"use strict";

// Every inspection route is identical apart from the resource key and the asset type it gates on.
// The tool and data view come from the URL itself (see InspectionUrl), so routes don't carry one.
const RoutineInspectionRouteFactory = function () {
  var createRoute = function ({ resourceKey, assetType }) {
    const handler = function ({ data, params }) {
      if (!HardAssetInspectionGate.isEnabledForAssetType(assetType)) {
        UrlRoutes.navigateToDefault();
        return;
      }

      return RouteFunctions.openNewOrExistingInspection({
        openInspectionFn: AssetRoutineMaintenanceController.showAssetRoutineMaintenanceModal,
        resourceKey: resourceKey,
        assetId: data.id,
        inspectionId: data.inspectionId,
        params: params,
      });
    };

    return {
      handler: handler,
      hooks: {
        leave: RouteFunctions.leaveTabbedModalRoute,
      },
    };
  };

  // Old asset-first inspection URLs (e.g. /ram/asset/outfall/1/routineInspection) don't say which
  // data view they belong to, so each one is pinned to the data view it has always opened in. The
  // route data lets the app boot into that tool before the redirect replaces the URL.
  var createLegacyRedirect = function ({ assetType, dataView }) {
    const handler = function ({ data, queryString }) {
      const path = InspectionUrl.get({
        tool: ToolFunctions.getToolByDataView(dataView),
        dataView,
        assetType,
        assetId: data.id,
        inspectionId: data.inspectionId,
      });

      UrlRoutes.navigate(queryString ? `${path}?${queryString}` : path, {
        historyAPIMethod: "replaceState",
      });
    };

    return {
      handler: handler,
      data: {
        dataView: dataView,
      },
    };
  };

  return {
    createRoute,
    createLegacyRedirect,
  };
};

module.exports = RoutineInspectionRouteFactory();

const AssetRoutineMaintenanceController = require("../../inspection/routineMaintenance/assetRoutineMaintenanceController");
const HardAssetInspectionGate = require("../../muni/hardAssetInspectionGate");
const InspectionUrl = require("./inspectionUrl");
const RouteFunctions = require("./routeFunctions");
const ToolFunctions = require("../../toolFunctions");
const UrlRoutes = require("../urlRoutes");
